import React, { useContext, useEffect, useState } from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';
import { Worker } from '../../../app/models/Workers';
import FundsRequestForm from './forms/FundsRequestForm';
import { defaultFundsRequestDataForm, FundsRequestDataForm, FundRequestReason } from '../../../app/models/Fund';
import useFundsRequestService from '../../../app/services/hooks/useFundsRequestService';
import { Currency } from '../../../app/models/Currency';
import { Society } from '../../../app/models/Society';

interface Props {
    fundRequestId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const FundsRequestEdit = ({
    fundRequestId,
    onSaved,
    onCancel,
    onError,
}: Props) => {
    const [ fundsRequest, setFundsRequest ] = useState<FundsRequestDataForm>({
        ...defaultFundsRequestDataForm
    });
    const [workers, setWorkers] = useState<Worker[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [societies, setSocieties] = useState<Society[]>([]);
    const [requestReasons, setRequestReasons] = useState<FundRequestReason[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    const { updateFundsRequest, 
        editFundsRequest, 
        fetchingCreateFundsRequest, 
    } = useFundsRequestService();

    const { showLoading, hideLoading } = useContext(AppContext);

    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando datos...');
        editFundsRequest(fundRequestId, {
            onSuccess: (response: ServiceResponse) => {
                const _fundRequest = response.data.fund_request
                _fundRequest.worker_total = [{
                    'worker_id': response.data.fund_request.worker_id, 
                    'total': response.data.fund_request.total,
                    'currency_id': response.data.fund_request.currency_id,
                    'transfer_reason_id': response.data.fund_request.transfer_reason_id,
                }]
                setFundsRequest(_fundRequest)
                setWorkers(response.data.worker);
                setRequestReasons(response.data.transfer_reasons);
                setCurrencies(response.data.currencies);
                setSocieties(response.data.societies);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    }, []);

    const update = () => {
        if (showLoading) showLoading('loading', 'Cargando solicitud...');
        updateFundsRequest(fundRequestId, fundsRequest, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };


    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingCreateFundsRequest ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <FundsRequestForm
                fundsRequest={fundsRequest}
                setFundsRequest={setFundsRequest}
                reasons={requestReasons}
                workers={workers}
                currencies={currencies}
                errorFields={errorFields}
                societies={societies}
                isEdit={true}
                byReason={false}
            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} />
                </div>
            </div>
        </>
    );
};

export default FundsRequestEdit;